import { render } from "./VariantsList.vue?vue&type=template&id=86f8438a&scoped=true"
import script from "./VariantsList.vue?vue&type=script&lang=js"
export * from "./VariantsList.vue?vue&type=script&lang=js"

import "./VariantsList.vue?vue&type=style&index=0&id=86f8438a&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/rb-redev/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-86f8438a"]])

export default __exports__